import { Tooltip } from "antd";
import { Component, ReactNode } from "react";
import {
  checkClipboardReadPermission,
  getMessage,
} from "utils/helpersInTs/helpersInTs";
import { strings } from "utils/localizedStrings";

export default class EclipseComponent extends Component<{
  data: {
    value: string | number;
    needShowLabel?: boolean;
    clickToCopy?: boolean;
  };
}> {
  constructor(props: {
    data: {
      value: string | number;
      needShowLabel?: boolean;
      clickToCopy?: boolean;
    };
  }) {
    super(props);
    this.clickToCopy = this.clickToCopy.bind(this);
  }

  private clickToCopy = async () => {
    let permission = await checkClipboardReadPermission();
    if (permission === "granted") {
      await window?.navigator?.clipboard
        ?.writeText(this.props?.data?.value as string)
        .then(() =>
          getMessage(
            `${strings.FileManagement.Placeholder.SavedValue} - ${this.props?.data?.value}`,
            4,
            "success"
          )
        );
    }
  };

  render(): ReactNode {
    const {
      value,
      needShowLabel = true,
      clickToCopy = false,
    } = this.props.data;
    return (
      <Tooltip
        placement="bottomLeft"
        title={
          <span
            onClick={async () =>
              clickToCopy === true && (await this.clickToCopy())
            }
            style={{ color: "#0f0f0f" }}
          >
            {value}
          </span>
        }
        color="#f5f7fa"
      >
        {needShowLabel ? (
          <span
            onClick={async () =>
              clickToCopy === true && (await this.clickToCopy())
            }
          >
            {value}
          </span>
        ) : (
          <></>
        )}
      </Tooltip>
    );
  }
}
